import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';

import { AuthenicationService } from '../../_services/authenication.service';
import { DoctorService } from '../../_services/doctor.service';
import { ToasterService } from '../../_services/toaster.service';

declare var $: any;

import { DynamicScriptLoaderServiceService } from "../../_services/dynamic-script-loader-service.service";

import {environment} from "../../../../../front/src/environments/environment";

@Component({
  selector: 'app-reschedule',
  templateUrl: './reschedule.component.html',
  styleUrls: ['./reschedule.component.css']
})
export class RescheduleComponent implements OnInit {

  sid: string = this.route.snapshot.params['sid'];
  uid: string = this.route.snapshot.params['uid'];
  userdetaild: string;
  id: string;
  usersid: string;
  doctors: any;
  avavility: any[] = [];
  selectedMode = [];
  selectedschedule = [];
  booked: any[] = [];
  bookingForm: FormGroup;
  submitted: Boolean = false;
  isdisplay: Boolean = true;
  isdisplaypre: Boolean = true;
  isdisplaymsg: Boolean = false;
  predate: string;
  preid: string;
  docid: string;
  pretime: string;
  baseUrl: string = environment.baseUrl;
  name: string;
  ischecked: Boolean = true;
  email: string;
  returnUrl: string;

  constructor(private formBuilder: FormBuilder,private router: Router, private route: ActivatedRoute, private dynamicScriptLoader: DynamicScriptLoaderServiceService, private authenicationService: AuthenicationService, private doctorservice: DoctorService,private toaster: ToasterService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();

    this.id = this.userdetaild['_id'];

    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    // if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
    //   this.authenicationService.logout();
    //   this.router.navigateByUrl('/login');
    // }

    this.bookingForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      troubles: ['', [Validators.required]],
      mode: ['', [Validators.required]],
      date: ['', ''],
      slot: ['', [Validators.required]],
    });

    const payload = {
      id: this.sid
    };
    this.getAppointmentById(payload);


    DynamicScriptLoaderServiceService.loadDynamicScript('https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/js/bootstrap-datepicker.min.js');

    const self = this;
    var date = new Date();
    date.setDate(date.getDate());
    $('.datepicker').datepicker({
      format: 'yyyy-mm-dd',
      todayHighlight: true,
      orientation: "auto",
      startDate: date,
      clearBtn: true
      // tslint:disable-next-line:only-arrow-functions
    }).on('changeDate', function(e) {
      self.onchangedate(e.format());
    });

    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';

  }

  onchangedate(date) {

    this.isdisplaypre = date == this.predate;
    const payload = {
      docid: this.docid,
      date: date
    };
    this.doctorsAvavilityByDate(payload);

  }

  get f() { return this.bookingForm.controls; }

  onSubmit(){
    this.submitted = true;

    // stop here if form is invalid
    if (this.bookingForm.invalid) {
      return;
    }

    let payl = {ids: this.preid.toString()};

    this.doctorservice.checkAppointmentBooked(payl)
      .subscribe(async (data: any) => {
          if (data && data.ResponseCode === '200') {
              await this.proceedToCheckout(this.bookingForm.controls);
          } else {
            this.toaster.showError('Session Booking','Session has been already booked by someone else');
          }
        },
        error => {
          this.toaster.showError('Session Booking',error);
        });

  }

  onChangeSlot(id){
    this.ischecked = false;
    this.preid = id;
  }

  doctorsAvavilityByDate(payload) {
    this.doctorservice.getDoctorAvavilityByDate(payload)
      .subscribe(
        (data: any) => {

          if (data && data.ResponseCode === '200') {
            this.avavility = data.avilibility;
            this.isdisplay = true;
            this.isdisplaymsg = false;
          } else {
            // alert(data.ResponseMessage);
            this.avavility = [];
            this.isdisplay = true;
            this.isdisplaymsg = true;
            console.log('no data found');
          }

        },
        error => {
          console.log('Doctor', error.error.ResponseMessage);
        });
  }

  rescheduleAppointment(payload) {
    this.doctorservice.rescheduleAppointment(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            //alert(data.ResponseMessage);
            this.router.navigate([`/appointments-list/all`]);
          } else {
            this.toaster.showError('Reschedule', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('Reschedule', error.error.ResponseMessage);
        });
  }

  getAppointmentById(payload) {
    this.doctorservice.getAppointmentById(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.booked = data.DoctorAppointment[0];
            this.bookingForm.setValue({
              name: this.booked['userObj']['users_name'],
              email: this.booked['userObj']['users_email'],
              troubles: this.booked['troubles'],
              mode: this.booked['appointmentMode'],
              date: this.booked['scheduleObj']['date'],
              slot: this.booked['scheduleObj']['start_time']+' - '+ this.booked['scheduleObj']['end_time'],
            });
            this.predate = this.booked['scheduleObj']['date'];
            this.preid = this.booked['scheduleObj']['_id'];
            this.docid = this.booked['docObj']['_id'];

            this.pretime = this.booked['scheduleObj']['start_time']+' - '+ this.booked['scheduleObj']['end_time']+' at '+ this.booked['scheduleObj']['location'];
            const dataaa = {
              docid: this.docid,
              date: this.booked['scheduleObj']['date']
            };
            this.doctorsAvavilityByDate(dataaa);

          } else {
            console.log(data.ResponseMessage);
            //this.toaster.showError('Add Patient', data.ResponseMessage);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          console.log(error.error.ResponseMessage);
          //this.toaster.showError('Add Patient', error.error.ResponseMessage);
        });
  }

  async proceedToCheckout(data){
    const formdata = {
      id: this.sid,
      appointmentMode: data.mode.value,
      scheduleId: this.preid,
      troubles: data.troubles.value,
      userid: this.id,

    };
    //this.router.navigate([`/checkout/${docid}/${mode}/${sid}/${desc}`]);
    //console.log(formdata);
    this.rescheduleAppointment(formdata);
  }

}
